import { CONFIG } from 'src/config-global';

export const formatImageUrl = (key: string) => `${CONFIG.cdnUrl}/${key}`;
